import React, { Component } from "react";
import { push } from "redux-little-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import mixpanel from "../../services/mixpanel";
import CaseCardList from "../../components/PostsList/components/CaseCardList";
import PostsList from "../../components/PostsList";
import PostCategoryFilter from "../../components/PostCategoryFilter";
import * as postActions from "../../actions";
import CASE_TYPES from "../../constants/caseTypes";
import PropTypes from "prop-types";
import NotFoundPage from "../../scenes/App404";
import "./index.css";

class Home extends Component {
  constructor(props) {
    super(props);
    this.applyCategoryFilter = this.applyCategoryFilter.bind(this);
    this.clearCategoryFilter = this.clearCategoryFilter.bind(this);
    this.navigateToCategory = this.navigateToCategory.bind(this);
    this.loadMorePosts = this.loadMorePosts.bind(this);
  }

  navigateToCategory(categoryId) {
    const categoryData = CASE_TYPES.find(caseType => caseType.index === categoryId - 1);
    this.props.actions.navigateToCategoryURL(`/category/${categoryData.caseTypeSlug}`, this.props.router.pathname);
  }

  render() {
    let postCategoryFilterValue = null;
    const currentRoutePath = this.props.router.pathname;
    const checkForCategory = currentRoutePath.slice(0, "/category/".length);

    if (checkForCategory === "/category/") {
      const categoryNameSlug = currentRoutePath.slice("/category/".length);
      const caseTypeSlugFound = CASE_TYPES.find(
        caseType => !caseType.hidden && caseType.caseTypeSlug.toLowerCase() === categoryNameSlug.toLowerCase()
      );
      if (caseTypeSlugFound) {
        postCategoryFilterValue = caseTypeSlugFound.index + 1;
      } else {
        return <NotFoundPage />;
      }
    }

    return (
      <div className="home-page">
        <PostCategoryFilter
          onChange={this.applyCategoryFilter}
          clearFilter={this.clearCategoryFilter}
          value={postCategoryFilterValue}
        />
        <PostsList
          posts={this.props.posts}
          loadMorePosts={this.loadMorePosts}
          notFoundData={{ msg: "No cases found" }}
          CaseListComponent={CaseCardList}
        />
      </div>
    );
  }

  applyCategoryFilter(categoryId) {
    if (categoryId) {
      this.props.actions.applyPostCategoryFilter(categoryId);
      const categoryData = CASE_TYPES.find(caseType => caseType.index === categoryId - 1);
      mixpanel.track("filter.category.choose", { "category name": categoryData.caseType });
      this.navigateToCategory(categoryId);
    } else {
      this.clearCategoryFilter();
    }
  }

  clearCategoryFilter() {
    this.props.actions.clearPostCategoryFilter();
    this.props.actions.clearPosts();
    this.props.actions.navigateToCategoryURL("/", this.props.router.pathname);
  }

  loadMorePosts(options) {
    if (this.props.posts.appliedFilters) {
      options.appliedFilters = this.props.posts.appliedFilters;
    }
    this.props.actions.loadMorePosts(options);
  }
}

Home.propTypes = {
  posts: PropTypes.object,
  actions: PropTypes.object,
  router: PropTypes.object,
};

const mapStateToProps = state => {
  return {
    posts: state.posts,
    router: state.router,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      ...bindActionCreators(postActions, dispatch),
      navigateToCategoryURL: (categoryURL, currentRouteURL) => {
        if (categoryURL !== currentRouteURL) {
          dispatch(push(categoryURL));
        }
      },
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/scenes/Feed/index.js